<div class="item-container">
  <div class="item-header">
    <h5 class="text-center" *ngIf="!isEdit">{{"COMMON.ADD" | translate}} {{"COMMON.CATEGORY" | translate}}</h5>
    <h5 class="text-center" *ngIf="isEdit">{{"COMMON.EDIT" | translate}} {{"COMMON.CATEGORY" | translate}}</h5>
    <div class="edit-icons" (click)="onCancel()">
      <i class="material-icons">close</i>
    </div>
  </div>
  <div class="item-content d-flex flex-column">
    <form action="" [formGroup]="addForm" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="col-md-6 mt-3 mt-3 mt-lg-4">
          <label for="">{{"COMMON.ENTER" | translate}} {{"COMMON.CATEGORY" | translate}}</label>
          <div class="form-input">
            <input type="text" class="form-control" formControlName="j_c" *ngIf="!isEmployeeSetting">
            <mat-select class="form-control" formControlName="j_c" *ngIf="isEmployeeSetting"
              (selectionChange)="onSelectCategory($event)" placeholder="Select Category ">
              <mat-option *ngFor="let item of categoryArr" [value]="item.j_c"> {{item.j_c}} </mat-option>
            </mat-select>
          </div>
          <mat-error *ngIf="isControlHasError('j_c','required')"> {{"COMMON.THR"|translate}}</mat-error>
        </div>
      </div>
      <div formArrayName="subcategories" class="mt-4">
        <label for="">{{"COMMON.ENTER" | translate}} {{"COMMON.SUBCATEGORY" | translate}}</label>
        <div class="row close-box" *ngFor="let subcategory of subcategories.controls; let i = index" [formGroupName]="i">
          <div class="close-ic" (click)="removeSubcategory(i)" *ngIf="i!==0">
            <i class="material-icons">close</i>
          </div>
          <div class=" col-sm-7 col-md-7 mb-3 ">
            <input formControlName="j_sc" placeholder="Subcategory Name" class="form-control" *ngIf="!isEmployeeSetting">
            <mat-select class="form-control" formControlName="j_sc" *ngIf="isEmployeeSetting" placeholder="Select Subcategory ">
              <mat-option *ngFor="let item of subCategoryArr" [value]="item.j_sc"> {{item.j_sc }} </mat-option>
            </mat-select>
            <mat-error *ngIf="subcategory.get('j_sc')?.touched && subcategory.get('j_sc')?.hasError('required')"> {{"COMMON.THR"|translate}}</mat-error>
          </div>
          <div class="col-sm-5 col-md-5 mb-3  d-flex  align-items-center">
            <div>
              <input formControlName="wages" type="number" placeholder="Rate" min="1" class="form-control">
              <mat-error *ngIf="subcategory.get('wages')?.touched && subcategory.get('wages')?.hasError('required')">{{"COMMON.THR"|translate}}</mat-error>
              <mat-error *ngIf="subcategory.get('wages')?.hasError('nonPositiveValidator') && subcategory.get('wages')?.value">
                Please enter value greter then 0.</mat-error>
            </div>
            <div class="action-icon  del-icon delete-img ms-2" (click)="removeSubcategory(i)">
              <i class="material-icons">close</i>
            </div>
          </div>
        </div>
      </div>
      <div class="i-box cursor-pointer mt-3 mt-sm-0">
        <span (click)="addSubcategory()"><i class="fas fa-plus"></i> {{"COMMON.ADD" | translate}} {{"COMMON.SUBCATEGORY" | translate}}</span>
      </div>
    </form>
  </div>
  <div>
    <mat-error *ngIf="categoryError">{{categoryError}}</mat-error>
  </div>
  <div class="row">
    <div class="col-md-6 m-auto">
      <button mat-raised-button color="primary" class="auth-form-btn mt-3 mt-lg-4" type="submit" (click)="onSubmit()">{{"BUTTON.SAVE" | translate }}</button>
    </div>
  </div>
</div>
<app-loading-spinner></app-loading-spinner>